import React from "react"
import PropTypes from "prop-types"

import { useTranslation } from "react-i18next"

import Delete from "components/GenericViews/Delete"
import { reverse } from "utils/urls"

export default function TourOperatorFeeDelete(props) {
  const { t } = useTranslation()

  return (
    <Delete
      modelName={t("Tour Operator Fee")}
      endpoint={`/fees/tour-operator-fees/${props.match.params.id}/`}
      successRoute={reverse("tourOperatorFeeList")}
      errorRoute={reverse("tourOperatorFeeList")}
    />
  )
}

TourOperatorFeeDelete.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.exact({
      id: PropTypes.string.isRequired,
    }),
  }).isRequired,
}
